import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import '../styles/style.css';
import { Button, InputAdornment, TextField, IconButton, Box } from "@mui/material";
import { defaultTextFieldStyle } from "../styles/textfieldStyles";
import Flag from '../../assets/images/flag.png'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDraft } from "../../app/store/reservationSlice";
import { useWindowSize } from "../hooks/useWindowSize";
import { chooseButtonTurquoiseStyle } from "../styles/buttonStyles";
import CloseIcon from '@mui/icons-material/Close';
import env from "../../app/config/envHelper";
import { useLazyGetCarNumberPlateQuery } from "../../app/store/api/carsApi";
// import Car from "./Car";

const RegisterPlate = forwardRef(({ hideSearchButton = false }, ref) => {

    const { t, i18n } = useTranslation();
    const { isDesktop, isTablet } = useWindowSize();
    const [fetchCarData, {data:carData,isLoading:loading,isError}] = useLazyGetCarNumberPlateQuery();
    const [ plate, setPlate ] = useState('');
    const draft = useSelector((state) => state.reservation.draft);
    const [ error, setError ] = useState(null);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isError) {
            setError(t('registerPlate.notFound'));
        }
        else{
            setError(null);
        }
    }, [isError]);

    useEffect(() => {
        if (carData) {
            dispatch(setDraft({ car: carData }));
        }
    }, [carData]);

    // Expose fetchCar function to parent component via ref
    useImperativeHandle(ref, () => ({
        search: () => fetchCar()
    }));
    
    const submitForm = (e) => {
        e.preventDefault();
        fetchCar();
    }

    const handlePlateChange = (e) => {
        const { value } = e.target;
        setPlate(value);
    }

    const handleMileageChange = (e) => {
        const { value } = e.target;
        dispatch(setDraft({ mileage: value }));
    }

    const fetchCar = () => {
        if(plate === "") {
            setError(t('registerPlate.plateRequired'));
            return;
        }
        fetchCarData(plate);
    }

    // Handler for X-mark
    const handleClearCar = () => {
        dispatch(setDraft({ car: null }));
    };

    // Use desktop/tablet layout if either is true
    const isWide = isDesktop || isTablet;

    return (
        <>
        <Box
            className="registerplate"
            sx={{
                display: isWide ? 'flex' : undefined,
                flexDirection: isWide ? 'column' : undefined,
                gap: isWide ? '16px' : undefined,
                alignItems: isWide ? 'flex-start' : undefined,
            }}
        >
            <form onSubmit={submitForm}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isWide ? '16px' : undefined,
                    width: '100%'
                }}
            >
                <Box
                    sx={{
                        display: isWide ? 'flex' : undefined,
                        flexDirection: isWide ? 'row' : undefined,
                        gap: isWide ? '24px' : undefined,
                        width: '100%'
                    }}
                >
                    <TextField 
                        sx={{...defaultTextFieldStyle, marginBottom: isWide ? 0 : '20px'}}
                        fullWidth
                        onChange={handlePlateChange}
                        name="plate"
                        value={draft.car ? draft.car.plate : plate}
                        disabled={draft.car ? true : false}
                        label={t('registerPlate.label')}
                        placeholder="ABC-123"
                        error={error ? true : false}
                        helperText={error ? error : ''}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <img
                                        src={Flag}
                                        alt="Flag"
                                        style={{ width: 24, height: 16 }}
                                    />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                draft.car ? (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={t('registerPlate.clearCar')}
                                            onClick={handleClearCar}
                                            edge="end"
                                            size="small"
                                            tabIndex={0}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null
                            )
                        }}
                    />
                    <TextField 
                        sx={{...defaultTextFieldStyle, marginBottom: isWide ? 0 : '20px'}}
                        fullWidth
                        placeholder="100000"
                        name="mileage"
                        type="number"
                        onChange={handleMileageChange}
                        value={draft.mileage || ''}
                        label={t('registerPlate.mileage')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        // disabled={!draft.car}
                    />
                </Box>
                { !hideSearchButton && !draft.car && (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className="infoButton"
                        type="submit"
                        sx={chooseButtonTurquoiseStyle}
                        variant="contained"
                        fullWidth
                        disabled={plate.length < 3 || !plate || draft.car || loading ? true : false}
                    >
                        {t('registerPlate.searchButton')}
                    </Button>
                </Box>
                )}
                
            </form>
            
        </Box>
        {/* { draft.car && <Car />} */}
        </>
    )
});

export default RegisterPlate;